module.exports = [
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1c9619a22f32012221bd59296dc9a1a2?size=200",
		"active": true,
		"name": "Damian Schenkelman",
		"id": "yenkel",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://avatars1.githubusercontent.com/u/655409?v=3&s=460",
		"active": true,
		"name": "Sandrino Di Mattia",
		"id": "sandrino",
		"title": "Product Owner"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5196c6f42d47f5583bbce2120affd4b1?size=200",
		"active": true,
		"name": "Matías Woloski",
		"id": "matias",
		"title": "Co-Founder, CTO"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/53f70144dc9d7c76455fa91f858d4cec?size=200",
		"active": true,
		"name": "Tomasz Janczuk",
		"id": "tomek",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/bb92524137114d812aa1cbbe70d35365?size=200",
		"active": true,
		"name": "Geoffrey Goodman",
		"id": "geoff",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://gravatar.com/avatar/355ebc2fef7f2c3d095887cb2920041f?size=200",
		"active": true,
		"name": "Richard Seldon",
		"id": "richard.seldon",
		"title": "Customer Success Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/34f27c88555c8c99b965d8137e16bfd9?size=200",
		"active": true,
		"name": "Cristian Douce",
		"id": "cristian",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/1329d9e3f4bc1d233788c89c04410bfe.png?size=200",
		"active": true,
		"name": "Victor Fernandez",
		"id": "victor",
		"title": "Lead Designer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/b93af62499ed0f76f280acb37913f15d.png?size=200",
		"active": true,
		"name": "Hernan Zalazar",
		"id": "hernan",
		"title": "Engineer (Native UX)"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4d44bd6c8bbd97dfeb5e9c299aaa68c5?size=200",
		"active": true,
		"name": "Jose Romaniello",
		"title": "Head Of Engineering",
		"id": "jose"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/35b47dce0e2c9ced8b500dca20e1a657.png?size=200",
		"active": true,
		"name": "Benjamín Flores",
		"id": "benjamin",
		"title": "User Interface Developer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/43103c16a95db00e7bab1f34d4d6ff8c?size=200",
		"active": true,
		"name": "Sebastian Iacomuzzi",
		"id": "sebastian.iacomuzzi",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/647b1eea820b3fc8a5aee0383930b888.png?size=200",
		"active": true,
		"name": "Pablo Terradillos",
		"id": "pablo.terradillos",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/jared-0dad95f6ee.png",
		"active": true,
		"name": "Jared Hanson",
		"id": "jared",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/german-3aa35d2747.png",
		"active": true,
		"name": "Germán Lena",
		"id": "german",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/da735b48d8300a97640149156b650305.png?size=200",
		"active": true,
		"name": "Luciano Balmaceda",
		"id": "luciano.balmaceda",
		"title": "Mobile Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/7d590747a0cd8e24a4c86dd5fd9990ef?size=200",
		"active": true,
		"name": "Hernán Tierno",
		"id": "hernan.tierno",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/05a4170856a6157f81319595e42fdc5b?size=200",
		"active": false,
		"name": "Gabriel Andretta",
		"id": "gabriel",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/73beae90bfcfea6bb084d34120e8b9cf?size=200",
		"active": false,
		"name": "Chris Keyser",
		"id": "chris",
		"title": "Product Owner, Appliance"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/977b4137e1b2dd12d168726ede712b68?size=200",
		"active": true,
		"name": "Martin Cabral",
		"id": "martin.cabral",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/ef8017f9c3c5a3264839361d977adcce?s=200",
		"active": true,
		"name": "Tomás Chernov",
		"id": "tomas.chernov",
		"title": "Front End Developer"
	},
	{
		"avatarUrl": "https://0.gravatar.com/avatar/a1c61dfb3670fa0617364f5179cc13b0.png?s=200",
		"active": true,
		"name": "Damian Fortuna",
		"id": "damian.fortuna",
		"title": "Front End Developer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ca578185f64251739569feed94986612?s=80",
		"active": true,
		"name": "Silvio Massari",
		"id": "silvio.massari",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/6e9c8a65f5b0f9bb57c53cdc40feecac.jpg?s=200",
		"active": true,
		"id": "marcos.castany",
		"name": "Marcos Castany",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://es.gravatar.com/userimage/20584812/aa6c2ef56cd36ad3bc497ef8d39ec2f9.jpg",
		"active": true,
		"name": "Yohanna Etchemendy",
		"id": "yohanna.etchemendy",
		"title": "Product Designer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a5878db74baa36ad0ae9cda759f9f2f8.jpg?s=200",
		"active": true,
		"name": "Javier Centurion",
		"id": "javier.centurion",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/09951bbb702cfdad0e1ce7b82dd9a637?s=200",
		"active": true,
		"name": "Nicolas Ulrich",
		"id": "nicolas.ulrich",
		"title": "Mobile Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/5dbe52812be440138ca34a4dc8bc80c0?s=200",
		"active": true,
		"name": "Alex Stanciu",
		"id": "alex",
		"title": "Product Owner"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/e42511d0034e0f3936941867ebdd8aea?s=200",
		"active": true,
		"name": "Bob Brumfield",
		"id": "bob.brumfield",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://www.gravatar.com/avatar/4ff2f1955778896cc06318b342dabf55?size=200",
		"active": true,
		"name": "Maria Paktiti",
		"id": "maria",
		"title": "Technical Writer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/28c9ec2561e35b62fab2820e14d1bf46?size=200",
		"active": true,
		"name": "Hugo Arregui",
		"id": "hugo.arregui",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/87daf4c39b1bded1f7ee5a8b4d4827a9?s=200",
		"active": true,
		"id": "eduardo.diaz",
		"name": "Eduardo Díaz Sanabria",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/9ccf8645ff4daa837dec9ca6fed6a0de?size=200",
		"active": true,
		"name": "Jason Strutz",
		"id": "jason.strutz",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/8e5a8216a606127a787669d99de86ee2/?size=200",
		"active": true,
		"name": "Carlos Mostek",
		"id": "carlos.mostek",
		"title": "CS Solutions Architect"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/36d0024e9a998273f9f5a5986cca232c?size=200",
		"active": true,
		"name": "Samuel Judson",
		"id": "samuel.judson",
		"title": "Application Security Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/e51bcc80714c984d8a1a2a3c572a3467?size=200",
		"active": true,
		"name": "Fredrik Liljegren",
		"id": "fredrik.liljegren",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/a7e145a62540d8e63e275c494b235437?s=200",
		"active": true,
		"name": "Rikaard Hosein",
		"id": "rikaard.hosein",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/1b431a32be50c8f1ea8c2297685cf77b?size=200",
		"active": true,
		"name": "Martin Walsh",
		"id": "martin.walsh",
		"title": "iOS Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/b6b7b936f75e1eeba8aeef306db1f764/?size=200",
		"active": true,
		"name": "José Luis Diaz",
		"id": "jose.luis.diaz",
		"title": "Engineer"
	},
	{
		"avatarUrl": "https://secure.gravatar.com/avatar/72956a2f6ee6c25ad00d194cf7543719/?size=200",
		"active": true,
		"name": "Luís Deschamps Rudge",
		"id": "luis.rudge",
		"title": "Front End Engineer"
	},
	{
		"avatarUrl": "https://s.gravatar.com/avatar/ea03ba48f7041d9bf675a067806d9d76?size=200",
		"active": true,
		"name": "Dirceu Pereira Tiegs",
		"title": "Engineer",
		"id": "dirceu"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/people.json
// module id = 1375
// module chunks = 0